module.exports = __webpack_public_path__ + "img/pn.32c4185.svg";